import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
const TrialBanner = () => {
  const navigate = useNavigate();
  const [showUpgradeContactModal, setShowUpgradeContactModal] = useState(false);
  const schoolData = useSelector((state) => state?.authSlice?.schoolDetail);
  const userData = useSelector((state) => state?.authSlice?.userData?.payload);

  const isTrial = schoolData?.isTrial;
  const role = userData?.role;

  if (!isTrial || role !== "School") {
    return null;
  }

  const trialEndDate = moment(schoolData?.trialEndDate);
  const today = moment();
  const daysRemaining = Math.max(0, trialEndDate.diff(today, 'days'));
  
  const teachersCount = schoolData?.maxTutorsWorking || 0;
  const maxTeachers = schoolData?.maxTutors || 0;
  const teacherPercentage = maxTeachers > 0 ? (teachersCount / maxTeachers) * 100 : 0;

  let stateClass = "";
  let icon = null;
  let statusText = "";
  let infoText = "";
  let buttonText = "";

  if (daysRemaining <= 0) {
    stateClass = "trial-banner-expired";
    statusText = "Trial Ended";
    infoText = "Your organisation is now read-only.";
    buttonText = "Upgrade account";
    icon = (
      <svg className="trial-banner-icon" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" />
      </svg>
    );
  } else if (daysRemaining <= 3) {
    stateClass = "trial-banner-critical";
    statusText = `Only ${daysRemaining} days left!`;
    infoText = "Upgrade now to keep your organisation active.";
    buttonText = "Upgrade account";
    icon = (
      <svg className="trial-banner-icon" fill="currentColor" viewBox="0 0 24 24">
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
      </svg>
    );
  } else if (daysRemaining <= 7) {
    stateClass = "trial-banner-approaching";
    statusText = "Trial ending soon";
    infoText = `${daysRemaining} days remaining`;
    buttonText = "Upgrade account";
    icon = (
      <svg className="trial-banner-icon" fill="currentColor" viewBox="0 0 24 24">
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
      </svg>
    );
  } else {
    stateClass = "trial-banner-active";
    statusText = "Trial Active";
    infoText = `${daysRemaining} days remaining`;
    buttonText = "Upgrade account";
    icon = (
      <svg className="trial-banner-icon" fill="currentColor" viewBox="0 0 24 24">
        <path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
      </svg>
    );
  }



  return (
    <>
      <div className={`trial-banner-container ${stateClass}`}>
        <div className="trial-banner-left">
          <div className="trial-banner-status">
            {icon}
            {statusText}
          </div>
          
          {daysRemaining > 3 ? (
            <>
              <div className="trial-banner-divider"></div>
              <div className="trial-banner-info">
                <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24"><path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z"/></svg>
                {infoText}
              </div>
            </>
          ) : (
            <div className="trial-banner-info" style={{ marginLeft: '-8px' }}>
              <span style={{ fontWeight: '900', fontSize: '18px' }}>·</span>
              <span>{infoText}</span>
            </div>
          )}

          <div className="trial-banner-divider"></div>
          
          <div className="trial-banner-info">
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24"><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/></svg>
            {teachersCount} / {maxTeachers} Teachers
          </div>
          
          <div className="trial-progress-bar">
            <div className="trial-progress-fill" style={{ width: `${teacherPercentage}%` }}></div>
          </div>
        </div>

        <div className="trial-banner-right">
          <button className="trial-banner-btn" onClick={() => setShowUpgradeContactModal(true)}>
            {buttonText}
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24"><path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"/></svg>
          </button>
        </div>
      </div>

      <Modal show={showUpgradeContactModal} onHide={() => setShowUpgradeContactModal(false)} centered className="upgrade-contact-modal">
        <Modal.Header closeButton style={{ borderBottom: "none", paddingBottom: 0 }}>
        </Modal.Header>
        <Modal.Body className="text-center px-4 pb-5 pt-0">
          <div className="mb-4 d-flex justify-content-center">
            <div style={{ width: "72px", height: "72px", borderRadius: "50%", background: "rgba(223, 27, 136, 0.08)", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 16L22 4L16 8L12 3L8 8L2 4L5 16H19ZM5 18V20H19V18H5Z" fill="var(--accent-pink)"/>
              </svg>
            </div>
          </div>
          <h3 className="mb-3" style={{ color: "var(--primary)", fontWeight: "700", fontSize: "24px" }}>
            Upgrade to Full Account
          </h3>
          <p className="mb-4" style={{ color: "#555", fontSize: "15px", lineHeight: "1.6", padding: "0 10px" }}>
            Please contact the Administrator to upgrade your organisation's account and unlock all features.
          </p>
          
          <a 
            href="mailto:info@yipiyap.co.uk" 
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              background: "#f8f9fa",
              border: "1px solid #e9ecef",
              padding: "14px 24px",
              borderRadius: "12px",
              color: "var(--primary)",
              textDecoration: "none",
              fontWeight: "600",
              fontSize: "16px",
              marginBottom: "28px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.04)"
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z" fill="var(--accent-pink)"/>
            </svg>
            info@yipiyap.co.uk
          </a>

          <div className="d-flex justify-content-center">
            <button 
              className="submit" 
              onClick={() => setShowUpgradeContactModal(false)}
              style={{ width: "100%", maxWidth: "200px", borderRadius: "10px", fontWeight: "600", padding: "12px 0", letterSpacing: "0.5px" }}
            >
              Got it
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default TrialBanner;
